import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';

interface WelcomeModalProps {
  open: boolean;
  onClose: () => void;
}

export const WelcomeModal: React.FC<WelcomeModalProps> = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Welcome to SafeHaven</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Your Wildfire Safety Advisor
          </Typography>
          <Typography paragraph>
            SafeHaven helps you understand and improve your home's wildfire safety. 
            Our AI-powered system analyzes your property details and provides personalized 
            recommendations to protect your home from wildfires.
          </Typography>
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            How it works:
          </Typography>
          <Typography component="ol" sx={{ pl: 2 }}>
            <li>Enter your property address</li>
            <li>Review the property details we find</li>
            <li>Get personalized wildfire safety recommendations</li>
            <li>Chat with our AI to learn more about implementing the recommendations</li>
          </Typography>
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            Key Features:
          </Typography>
          <Typography component="ul" sx={{ pl: 2 }}>
            <li>Property-specific safety analysis</li>
            <li>Interactive chat for detailed guidance</li>
            <li>Save and track multiple properties</li>
            <li>Expert recommendations from reliable sources</li>
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Get Started
        </Button>
      </DialogActions>
    </Dialog>
  );
};
